require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.0@core-js/library/fn/is-iterable.js
// module id = 420
// module chunks = 0 1